// extracted by mini-css-extract-plugin
export default {"successLabel":"styles_successLabel__Vx9Nx","errorLabel":"styles_errorLabel__7SiU+"};